export enum GPT_MODEL_TYPES {
    // "gpt-3_5-turbo-0125" = "0",
    // "gpt-4" = "1",
    // "gpt-4-32k" = "2",
    "gpt-4o" = "3",
    "gpt-4o-mini" = "4",
    "gpt-4.1-mini" = "13",
    "gpt-4.1" = "14",
}

export enum GPT_MODEL_TYPES_STAGE {
    "claude3.5-haiku-anthropic" = "7",
    "claude3.5-sonnet-anthropic" = "8",
    "llama3.3-70b-afs" = "9",
    "llama3.3-70b-fast-groq" = "10",
    "llama3.1-8b-twsc" = "11",
    // "llama3.1-8b-groq" = "19", 先暫時註解，等待後端更新
}

export enum RAG_MODEL_TYPES {
    "CH.RAG_Basic" = "0",
    "CH.RAG_Advanced" = "1",
}

export enum DYNAMIC_TASK_TYPE {
    "CH.Dynamic_Hint_Task_Type_0" = "0",
    "CH.Dynamic_Hint_Task_Type_1" = "1",
}
//在 i18n google sheet中的 character 改寫task名稱,
//如果資料從後端來時有"2","3"的話,請在這裡加入enum，並在i18n google sheet中加入對應的名稱

export const DYNAMIC_hint_number = ["1", "2", "3"];

export enum LLM_STATUS {
    SUCCESS = "success",
    CANCELED = "canceled",
    UNKNOWN = "unknown",
    ERROR = "error",
    TIMEOUT = "timeout",
}
